import React, { useState } from "react";
import { Button, CheckPicker, Icon, SelectPicker, Table, Input, FormControl } from "rsuite";
import styled from "styled-components";

import BaseTable from "components/base/BaseTable";
import ModalRemoveAccountManager from "./ModalRemoveAccountManager";

const { Cell, Column, HeaderCell } = Table;


export default ({
    data = [],
    loading,
    teamLeadList,
    userList,
    billingList,
    handleRowEdit,
    modifyAccountManager,
    removeAccountManager,
    getAccountManagersList,
    ...props
}) => {

    const [forms, setForms] = useState(new Map());
    const [rowsLoading, setRowsLoading] = useState([]);
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [removeData, setRemoveData] = useState(null);
    const [removeDataLoading, setRemoveDataLoading] = useState(null);

    // const accountManagerPermissions = [
    //     {
    //         value: "access_list_notification_daily",
    //         label: "Send access list daily"
    //     },
    //     {
    //         value: "access_list_notification_apperance",
    //         label: "Send access lists per appearance"
    //     }
    // ];

    const changeForm = (name, value, id) => {
        const formsCopy = new Map(forms);
        const currentForm = forms.get(id);
        let newValue;
        if (value instanceof Object && value.hasOwnProperty(name)) {
            newValue = { [name]: value[name] }
        } else {
            newValue = { [name]: value };
        }

        formsCopy.set(id, { ...currentForm, ...newValue });
        setForms(formsCopy);
    };

    const modifyRow = async (rowData) => {
        setRowsLoading([...rowsLoading, rowData.id]);
        const params = forms.get(rowData.id);
        if (!params.name) {
            setRowsLoading(rowsLoading.filter(item => item !== rowData.id));
            return;
        }
        if (!params.email) {
            setRowsLoading(rowsLoading.filter(item => item !== rowData.id));
            return;
        }
        const res = await modifyAccountManager(params);

        if (!res) {
            setRowsLoading(rowsLoading.filter(item => item !== rowData.id));
            return;
        }
        if (!res.account_manager) {
            const formsCopy = new Map(forms);
            if (forms.has(rowData.id)) {
                formsCopy.delete(rowData.id);
            }
            setForms(formsCopy);
            setRowsLoading(rowsLoading.filter(item => item !== rowData.id));
            return;
        }
        setItemEditing(res.account_manager);
        getAccountManagersList();
        setRowsLoading(rowsLoading.filter(item => item !== rowData.id));
    };

    const deleteRow = async () => {
        setRemoveDataLoading(true);
        const res = await removeAccountManager(removeData.id);
        if (res) {
            // await getAccountManagersList();
            // if (res.account_manager)
            //     setItemEditing(res.account_manager);

            await getAccountManagersList()
                .then(response => {
                    setShowRemoveModal(false);
                    setRemoveData(null);
                })
                .finally(() => {
                    setRemoveDataLoading(false);
                });
        }

    };

    const setItemEditing = (rowData) => {
        const formsCopy = new Map(forms);
        if (forms.has(rowData.id)) {
            formsCopy.delete(rowData.id);
        } else {
            formsCopy.set(rowData.id, {
                account_manager_id: rowData.id,
                email: rowData.email,
                name: rowData.name,
                account_user_teamlead_id: rowData.account_user_teamlead && rowData.account_user_teamlead.account_user_id,
                account_user_manager_id_list: rowData.account_user_manager_list
                    ? rowData.account_user_manager_list.map(item => item.account_user_id)
                    : null,
                teams_link: rowData.teams_link,
                permission_list: rowData.permission_list
            })
        }
        setForms(formsCopy);
    };

    return (
        <>
            <StyledTable
                className={"tableFilters"}
                shouldUpdateScroll={false}
                headerHeight={46}
                height={600}
                // autoHeight
                rowClassName={(rowData) => {
                    if (rowData) {
                        return rowData.active ? "" : "inactive";
                    }
                }}
                wordWrap
                data={[...data]}
                {...{
                    loading
                }}
                {...props}
            >

                <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">AM</span>
                    </HeaderCell>
                    <Cell dataKey={"name"}>
                        {(rowData) => {
                            if (forms.has(rowData.id)) {
                                const editableRow = forms.get(rowData.id);
                                return <div className="rs-form-control-wrapper">
                                    <EditField
                                        as={Input}
                                        value={editableRow["name"]}
                                        name="name"
                                        placeholder={"Name"}
                                        onChange={(val) => changeForm("name", val, rowData.id)}
                                    />
                                    {!editableRow["name"] &&
                                        <EditFieldError text="Required" />
                                    }
                                </div>
                            }
                            return <span className="tableFilters__previewText">{rowData["name"]}</span>
                        }}
                    </Cell>
                </Column>

                <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">Email</span>
                    </HeaderCell>
                    <Cell dataKey={"email"}>
                        {(rowData) => {
                            if (forms.has(rowData.id)) {
                                const editableRow = forms.get(rowData.id);
                                return <div className="rs-form-control-wrapper">
                                    <EditField
                                        as={Input}
                                        value={editableRow["email"]}
                                        name="email"
                                        placeholder={"Email"}
                                        onChange={(val) => changeForm("email", val, rowData.id)}
                                    />
                                    {!editableRow["email"] &&
                                        <EditFieldError text="Required" />
                                    }
                                </div>
                            }
                            return <span className="tableFilters__previewText">{rowData["email"]}</span>
                        }}
                    </Cell>
                </Column>

                <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">Team Lead</span>
                    </HeaderCell>
                    <Cell dataKey={"teamlead_name"}>
                        {(rowData) => {
                            if (forms.has(rowData.id)) {
                                const editableRow = forms.get(rowData.id);
                                return <EditField
                                    as={SelectPicker}
                                    cleanable={false}
                                    searchable={false}
                                    data={teamLeadList}
                                    value={editableRow["account_user_teamlead_id"]}
                                    valueKey="id"
                                    labelKey="name"
                                    name="account_user_teamlead_id"
                                    placeholder={"Team Lead"}
                                    onChange={(val) => changeForm("account_user_teamlead_id", val, rowData.id)}
                                    menuStyle={{ width: 280 }}
                                />
                            }
                            return <span className="tableFilters__previewText">
                                {rowData.account_user_teamlead
                                    ? rowData.account_user_teamlead.account_user_name
                                    : ""
                                }
                            </span>
                        }}
                    </Cell>
                </Column>

                <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">AM from Billing</span>
                    </HeaderCell>
                    <Cell dataKey={"name"}>
                        {(rowData) => {
                            const billingItem = rowData["billing_acm_key"] && billingList.find(item => item.ACM_KEY === rowData["billing_acm_key"]);
                            return (
                                <span className="tableFilters__previewText">
                                    {rowData["billing_acm_key"]
                                        ? billingItem ? billingItem["ACM_NAME"] : ""
                                        : ""
                                    }
                                </span>
                            )
                        }}
                    </Cell>
                </Column>

                <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">Users</span>
                    </HeaderCell>
                    <Cell dataKey={"account_user_list"}>
                        {(rowData) => {
                            if (forms.has(rowData.id)) {
                                const editableRow = forms.get(rowData.id);
                                return <EditField
                                    cleanable={true}
                                    searchable={false}
                                    value={editableRow.account_user_manager_id_list}
                                    data={userList}
                                    valueKey="id"
                                    labelKey="name"
                                    name="account_user_manager_id_list"
                                    placeholder={"Users"}
                                    sticky
                                    as={CheckPicker}
                                    onChange={(val) => changeForm("account_user_manager_id_list", val, rowData.id)}
                                    menuStyle={{ width: 280 }}
                                />
                            }
                            const users = rowData.account_user_manager_list && rowData.account_user_manager_list.map(item => item.account_user_name).join(", ");
                            return <span className="tableFilters__previewText">{users || ""}</span>
                        }}
                    </Cell>
                </Column>

                <Column flexGrow={2} minWidth={200}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">Teams</span>
                    </HeaderCell>
                    <Cell dataKey="teams_link">
                        {(rowData) => {
                            if (forms.has(rowData.id)) {
                                const editableRow = forms.get(rowData.id);
                                return <div className="rs-form-control-wrapper">
                                    <EditField
                                        as={Input}
                                        componentClass="textarea"
                                        rows={3}
                                        value={editableRow["teams_link"]}
                                        name="teams_link"
                                        placeholder="Teams"
                                        onChange={(val) => changeForm("teams_link", val, rowData.id)}
                                    />
                                </div>
                            }
                            return <span className="tableFilters__previewText">{rowData["teams_link"]}</span>
                        }}
                    </Cell>
                </Column>

                {/* <Column flexGrow={1} minWidth={130}>
                    <HeaderCell>
                        <span className="tableFilters__headerText">Permissions</span>
                    </HeaderCell>
                    <Cell dataKey="permission_list">
                        {(rowData) => {
                            if ( forms.has(rowData.id) ) {
                                const notEditableRow = forms.has(rowData.id) ? forms.get(rowData.id) : false;
                                return <Form
                                    formDefaultValue={rowData}
                                    onChange={(value) => changeForm("permission_list", value, rowData.id)}
                                    className="rs-form-control-wrapper"
                                >
                                    <CustomField
                                        data={accountManagerPermissions}
                                        readOnly={!notEditableRow}
                                        accepter={CheckPicker}
                                        searchable={false}
                                        name="permission_list"
                                        placeholder="Permissions"
                                        className="tableFilters_field"
                                    />
                                </Form>
                            }
                            const permissions = rowData.permission_list && rowData.permission_list.map(perm => {
                                const foundPermission = Object.values(accountManagerPermissions).find(acc_man_perm => acc_man_perm.value === perm);
                                if (foundPermission) {
                                    return foundPermission.label;
                                }
                                return null
                            }).join(", ");
                            return <span className="tableFilters__previewText">{permissions || ""}</span>
                        }}
                    </Cell>
                </Column> */}

                <Column width={120}>
                    <HeaderCell></HeaderCell>
                    <Cell>
                        {rowData => {
                            const rowLoading = rowsLoading.includes(rowData.id);
                            return <div className="tableFilters_buttons">

                                {!forms.has(rowData.id)
                                    ? <Button
                                        size="sm"
                                        color="lightblue"
                                        disabled={rowLoading}
                                        onClick={() => setItemEditing(rowData)}
                                    >
                                        <Icon icon="edit2" />
                                    </Button>
                                    : <>
                                        <Button
                                            size="sm"
                                            color="green"
                                            disabled={rowLoading}
                                            onClick={() => modifyRow(rowData)}
                                        >
                                            <Icon icon="check-circle" />
                                        </Button>

                                        <Button
                                            size="sm"
                                            color="red"
                                            disabled={rowLoading}
                                            onClick={() => setItemEditing(rowData)}
                                        >
                                            <Icon icon="close-circle" />
                                        </Button>
                                    </>
                                }

                                <Button
                                    size="sm"
                                    color="red"
                                    disabled={rowLoading}
                                    onClick={() => {
                                        setRemoveData(rowData);
                                        setShowRemoveModal(true);
                                    }}
                                >
                                    <Icon icon="trash2" />
                                </Button>
                            </div>
                        }}
                    </Cell>
                </Column>

            </StyledTable>

            <ModalRemoveAccountManager
                show={showRemoveModal}
                onSubmit={deleteRow}
                onClose={() => setShowRemoveModal(false)}
                disabled={removeDataLoading}
            />

        </>
    )
}

const StyledTable = styled(BaseTable)`
    && {
    
        .tableFilters__previewText {
            display: block;
            line-height: 20px;
            margin-top: 7px;
            word-wrap: break-word;
        }
        
        .tableFilters_buttons {
            height: 20px;
            margin-top: 7px;
        }

        .rs-btn.rs-btn-default.rs-btn-sm {
            margin-right: 8px;
        }

        .rs-table-row.inactive .rs-table-cell {
            background: var(--color-bg); //#c3c2d1
        }
    }
`;


const EditFieldError = ({ text }) => (
    <div className="rs-error-message-wrapper rs-form-control-message-wrapper rs-error-message-placement-top-end">
        <span className="rs-error-message rs-error-message-show">
            <span className="rs-error-message-arrow"></span>
            <span className="rs-error-message-inner">{text}</span>
        </span>
    </div>
);

const EditField = styled(FormControl).attrs(props => ({
    className: "tableFilters_field",
    errorPlacement: "topEnd",
    type: "text",
}))`
`;

